import { render, staticRenderFns } from "./FormEditWidget.vue?vue&type=template&id=1b10de67&"
import script from "./FormEditWidget.vue?vue&type=script&lang=js&"
export * from "./FormEditWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports